import React from 'react';
import { Formik } from 'formik';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { flow } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import ButtonPayActionsComponent from '../components/ButtonPayActions.component';
import { FieldCurrencyComponentDigits } from '@giro/shared-components/Fields/FieldCurrency.component';
import FieldLabelFormikComponent from '@giro-pdv/components/FieldLabelFormik.component';

import TextFieldLabelComponent from '@giro-pdv/components/TextFieldLabel.component';

import PDVLayout from '../layouts/PDV.layout';

import UpdateAmountComponent from '../components/UpdateAmount.component';

import tablePayment from '../store/tablePayment';
import transactions from '../store/transactions';
import pinpad from '../store/pinpad';
import clients from '../store/clients';

const FormCartorio = () => {
  const dispatch = useDispatch();
  const formikRef: any = React.useRef(null);
  const client = useSelector(clients.selector.selectPayload);

  const dispatchRedux = {
    transactionsServicePost: flow(transactions.action.servicePost, dispatch),
    updateReturn: flow(tablePayment.action.updateReturn, dispatch),
    updateTypeTax: flow(tablePayment.action.updateTypeTax, dispatch),
  };

  const selectorRedux = {
    return: useSelector(tablePayment.selector.selectReturn),
    installmentSelected: useSelector(
      tablePayment.selector.selectInstallmentSelected
    ),
    transactionsLoading: useSelector(transactions.selector.selectLoading),
    state: useSelector(pinpad.selector.selectState),
  };

  React.useEffect(() => {
    if (selectorRedux.state.transaction_status === 'transaction_approved') {
      formikRef.current?.setFieldValue('total', 0);
    }
    return undefined;
  }, [selectorRedux.state.transaction_status]);

  let transactionTypes: any[] = [];

  if (client) transactionTypes = client.tipoTransacao?.split(',') || [];

  const initialValues = {
    client: null,
    service: null,
    total: null,
    segment: '16',
    dsIdentificacaoServico: null,
    dsIdentificacaoCliente: null,
    att_password: null,
    type_tax: ['ec', 'client'].includes(client?.taxaPadrao)
      ? client?.taxaPadrao
      : 'client',
    type_tax_credit: ['ec', 'client'].includes(client?.taxaPadrao)
      ? client?.taxaPadrao
      : 'client',
  };

  React.useEffect(() => {
    dispatchRedux.updateTypeTax(client?.taxaPadrao || 'client');
  }, [client?.taxaPadrao]);

  const onSubmit = () => {};

  const { type: paymentType } = selectorRedux.installmentSelected || {};

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      innerRef={formikRef}
      validateOnMount={true}
      enableReinitialize={true}
    >
      {({ values, setFieldValue }) => {
        return (
          <>
            <UpdateAmountComponent />
            <Box
              display="flex"
              flexDirection="column"
              gap={4}
              sx={{
                minHeight: { xs: 'auto', lg: 'calc(100vh - 252px)' },
              }}
            >
              <Box display="flex" flexDirection="column" gap={3}>
                <FieldLabelFormikComponent
                  size="small"
                  name="dsIdentificacaoServico"
                  label="Identificação do Serviço"
                />
                <FieldLabelFormikComponent
                  size="small"
                  name="dsIdentificacaoCliente"
                  label="Identificação do Cliente"
                />
                <FieldCurrencyComponentDigits
                  customInput={TextFieldLabelComponent}
                  size="small"
                  name="total"
                  label="Serviços"
                />
                <Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
                  <Box display="flex" flexDirection="column">
                    <Typography variant="trasso_heading_small">
                      Tipo de taxa
                    </Typography>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="portador"
                      name="radio-buttons-group"
                      onChange={(ev, value) => {
                        setFieldValue('type_tax', value);

                        dispatchRedux.updateTypeTax(value);

                        if (value === 'ec') {
                          dispatchRedux.updateReturn(0);
                        }
                      }}
                    >
                      {(transactionTypes.includes('1') || !client) && (
                        <FormControlLabel
                          value="client"
                          disabled={
                            paymentType === 'Débito' || paymentType === 'PIX'
                          }
                          checked={values.type_tax === 'client'}
                          control={
                            <Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: 'secondary.main',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="trasso_body_medium"
                              color="grey.800"
                            >
                              Cliente
                            </Typography>
                          }
                        />
                      )}
                      {(transactionTypes.includes('2') || !client) && (
                        <FormControlLabel
                          value="ec"
                          checked={values.type_tax === 'ec'}
                          control={
                            <Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: 'secondary.main',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="trasso_body_medium"
                              color="trasso.purple.100"
                            >
                              Cartório
                            </Typography>
                          }
                        />
                      )}
                    </RadioGroup>
                  </Box>
                </Box>
              </Box>
              <Box display="grid" gridTemplateColumns="1fr" gap={4}>
                <ButtonPayActionsComponent
                  loading={selectorRedux.transactionsLoading}
                  onClickPay={() =>
                    dispatchRedux.transactionsServicePost({
                      ...values,
                    })
                  }
                  disabledPay={
                    selectorRedux.transactionsLoading ||
                    selectorRedux.installmentSelected === null ||
                    Number((values as any).total) === 0
                  }
                  disabledSend={Number((values as any).total) === 0}
                />
              </Box>
            </Box>
          </>
        );
      }}
    </Formik>
  );
};

const CartorioBillingScreen = () => {
  return (
    <PDVLayout>
      <FormCartorio />
    </PDVLayout>
  );
};

export default CartorioBillingScreen;
